var render = function render(){var _vm=this,_c=_vm._self._c;return _c('level-formula-form',{attrs:{"formula":_vm.formula,"is-loading":_vm.isLoading,"entities-by-id":_vm.entitiesById},on:{"save":_vm.onSave,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }